$(document).ready(function () {
    $(".tom_cart_product_detail .tom_add_ins_content a.tom_editable_aim").on("click", function (e) {
        e.preventDefault();
        var tag_name = $(this).attr('data-tag-name');
        var tag_ki_type = $(this).attr('data-key-input').trim();
        var data_key_item = Number($(this).attr('data-key-item'));
        var InputText = $(this).prev().text().trim().replaceAll(' ', '~');
        var validation = false;
        var add_inc_identifyer = false;
        var linked_product_status = false;

        console.log('tag_ki_type', tag_ki_type)
        if (InputText.length > 0) {
            if (tag_ki_type == 'Add an Inscription') {
                if (tag_name == 'spurs_inscription') {
                    if (InputText.length > 40) {
                        $(this).parent().next().text("Maximum number of characters: 40");
                        $(this).parent().next().addClass('active');
                    } else {
                        validation = true;
                        add_inc_identifyer = true;
                    }
                } else if (tag_name == 'bits_inscription') {
                    if (InputText.length > 20) {
                        $(this).parent().next().text("Maximum number of characters: 20");
                        $(this).parent().next().addClass('active');
                    } else {
                        validation = true;
                        add_inc_identifyer = true;
                    }
                }
            } else if (tag_ki_type == 'Two Initials') {
                if (InputText.length > 2) {
                    $(this).parent().next().text("Maximum number of characters: 2");
                    $(this).parent().next().addClass('active');
                } else {
                    validation = true;
                }
            } else if (tag_ki_type == 'Three Initials') {
                if (InputText.length > 3) {
                    $(this).parent().next().text("Maximum number of characters: 3");
                    $(this).parent().next().addClass('active');
                } else {
                    validation = true;
                }
            } else if (tag_ki_type == 'Name') {
                if (InputText.length === 0) {
                    $(this).parent().next().text("Input must be filled out");
                    $(this).parent().next().addClass('active');
                } else {
                    validation = true;
                }
            } else if (tag_ki_type == 'Boot Size') {
                if (InputText.length === 0) {
                    $(this).parent().next().text("Input must be filled out");
                    $(this).parent().next().addClass('active');
                } else {
                    validation = true;
                }
            } else if (isSilverLettersField(tag_ki_type)) {
                console.log('3/16” silver letters ($16 per letter) -- >> Show');
                if (InputText.length > 10) {
                    $(this).parent().next().text("Maximum number of characters: 10");
                    $(this).parent().next().addClass('active');
                } else {
                    validation = true;
                    linked_product_status = true;
                }
            }
        } else {
            if (!isSilverLettersField(tag_ki_type)) {
                $(this).parent().next().text("Input must be filled out");
                // $('.crt_ai_error').text("Input must be filled out");
                $(this).parent().next().addClass('active');
            } else {
                validation = true;
                linked_product_status = true;
            }
        }

        console.log('validation', validation)
        if (validation) {
            var linked_product_data = null;

            if (linked_product_status) {
                var rawLinkedData = $(this).attr('data-linked-product');

                if (!rawLinkedData) {
                    // fallback: build it manually
                    var handle = $(this).closest('.cart-item').find('.cart-item__name').attr('href').split('/products/')[1].split('?')[0];
                    linked_product_data = handle + '--' + InputText;
                } else {
                    linked_product_data = rawLinkedData.trim().replaceAll(' ', '~');
                }
            }

            //console.log( $('.tom_editable_aim').not(this).length);
            $(this).parent().next().removeClass('active');

            var my_obj = {};
            if (add_inc_identifyer) {
                var append_msg = $(this).attr("data-extra-price-label");
                var new_input = $(this).attr('data-key-input');
                var new_value = $(this).prev().text();
                new_value = new_value + " |" + append_msg;
            } else {
                var new_input = $(this).attr('data-key-input');
                var new_value = $(this).prev().text();
            }
            // var new_input = $(this).attr('data-key-input');
            // var new_value = $(this).prev().text();
            if (isSilverLettersField(new_input)) {
                if (new_value != "") {
                    my_obj[new_input] = new_value;
                }
            } else {
                my_obj[new_input] = new_value;
            }

            var s = $(this).parents(".cart-item__details").find('.tom_editable_aim').not(this);
            s.each(function (e) {
                var data_key_input = $(this).attr("data-key-input");
                var data_key_value = $(this).attr("data-old-value");
                my_obj[data_key_input] = data_key_value;
            });
            if (!Object.keys(my_obj).length) {
                my_obj[null] = null
            }
            var currentProductQty = Number($(this).closest('.cart-item').find('.quantity__input').val() || 1);
            var list_item = {line: data_key_item, properties: my_obj, quantity: currentProductQty};
            //console.log(list_item);

            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(list_item)
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log("Update Properties Done");
                    console.log(linked_product_status);
                    if (linked_product_status) {
                        var parentProductQty = currentProductQty;
                        return syncLinkedSilverLetters(InputText, linked_product_data, parentProductQty)
                            .then(() => {
                                window.location.href = '/cart';
                            });
                    } else {
                        console.log('main redirection call');
                        window.location.href = '/cart';
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        if (tag_name == 'bits_inscription') {
            if (InputText.length > 20) {
                $(this).addClass('saveBtn');
            } else {
                $(this).removeClass('saveBtn');
            }
        } else if (tag_name == 'spurs_inscription') {
            if (InputText.length > 40) {
                $(this).addClass('saveBtn');
            } else {
                $(this).removeClass('saveBtn');
            }
        } else if (tag_ki_type == 'Two Initials') {
            if (InputText.length > 2) {
                $(this).addClass('saveBtn');
            } else {
                $(this).removeClass('saveBtn');
            }
        } else if (tag_ki_type == 'Boot Size') {
            if (InputText.length === 0) {
                $(this).addClass('saveBtn');
            } else {
                $(this).removeClass('saveBtn');
            }
        } else if (isSilverLettersField(tag_ki_type)) {
            if (InputText.length === 0) {
                $(this).addClass('saveBtn');
            } else {
                $(this).removeClass('saveBtn');
            }
        }
    });
    // second speical letter product code start

    // if( $('.tom_product_detail_content input[name="properties[3/16” silver letters ($16 per letter)]"]').length > 0 ){
    $(document).ajaxComplete(function (event, xhr, settings) {
        if (settings.url && settings.url.indexOf('/cart/add') !== -1) {
            if (isSilverLettersAddRequest(settings)) {
                return;
            }
            $.getJSON('/cart.json', function (e) {
                var cartItems = e.items || [];
                var parentItem = null;
                var silverLettersKey = '';

                cartItems.forEach(function (item) {
                    if (parentItem || !item || !item.properties || item.id === getSilverLettersProductId()) {
                        return;
                    }

                    Object.keys(item.properties).forEach(function (propertyName) {
                        if (!parentItem && isSilverLettersField(propertyName) && item.properties[propertyName]) {
                            parentItem = item;
                            silverLettersKey = propertyName;
                        }
                    });
                });

                if (!parentItem || !silverLettersKey) {
                    return;
                }

                var silverLettersValue = parentItem.properties[silverLettersKey] || '';
                var parentQty = Number(parentItem.quantity || 1);
                var silver_qty_length = silverLettersValue ? parentQty * silverLettersValue.length : 0;
                var silver_qty_length_char = silverLettersValue || '';
                var $produc_title = parentItem.handle + '--' + silverLettersValue.replaceAll(' ', '~');
                var existingSilverItem = null;

                cartItems.forEach(function (item) {
                    if (existingSilverItem || !item || item.id !== getSilverLettersProductId() || !item.properties) {
                        return;
                    }

                    if (item.properties['_For Product'] === $produc_title) {
                        existingSilverItem = item;
                    }
                });

                console.log('silver_qty_length', silver_qty_length);
                if (silver_qty_length > 0) {
                    if (existingSilverItem) {
                        if (Number(existingSilverItem.quantity || 0) !== silver_qty_length) {
                            $.ajax({
                                type: 'POST',
                                url: '/cart/change.js',
                                data: {
                                    id: existingSilverItem.key,
                                    quantity: silver_qty_length,
                                    properties: existingSilverItem.properties
                                },
                                dataType: 'json'
                            });
                        }
                    } else {
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: 'quantity=' + silver_qty_length + '&id=' + getSilverLettersProductId() + '&properties[_For Product]=' + encodeURIComponent($produc_title) + '&properties[silver letters]=' + encodeURIComponent(silver_qty_length_char),
                            dataType: 'json',
                            success: function (line_item) {
                                if ((typeof callback) === 'function') {
                                    callback(line_item);
                                } else {
                                    console.log('added');
                                }
                            },
                            error: function (XMLHttpRequest, textStatus) {
                                Shopify.onError(XMLHttpRequest, textStatus);
                            }
                        });
                    }
                }
            });
        }
    });
    // }


    // second speical letter product code end
    // --------------------------------------
    $('.cart_remove_btn').click(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var $sibling_product = $(this).attr('data-product-title');
        // console.log('$sibling_product', $sibling_product);

        var $cart_remove_url = $(this).attr('data-remove-product-url');
        var $cart_remove_item = $(this).attr('data-item-key');

        if ($sibling_product !== undefined) {
            var $sibling_remove_product_url = $('.tom_editable_aim.special_char[data-old-value="' + $sibling_product + '"]').attr('data-p-key');
            var $all_qty = Number($('.tom_editable_aim.special_char[data-old-value="' + $sibling_product + '"]').attr('data-qty'));
            var $main_product_qty = Number($(this).closest('.cart-item').find('.quantity__input').val() || 1);
            var $sibling_remove_product_qty = Number($sibling_product.split('--')[1].length) * $main_product_qty;
            var $qty_left = Math.max($all_qty - $sibling_remove_product_qty, 0);

            var data = {updates: {}};
            data.updates[$cart_remove_item] = 0;

            // console.log('$sibling_remove_product_url', $sibling_remove_product_url);

            if ($sibling_remove_product_url !== undefined) {
                data.updates[$sibling_remove_product_url] = $qty_left;
                // console.log('$sibling_remove_product_url != undefined', $qty_left);

                jQuery.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: data,
                    dataType: "json",
                    success: function () {
                        window.location.reload();
                    },
                });
            } else {
                // console.log('normal remove product');
                window.location.href = $cart_remove_url;
            }
        } else {

            var $linkedProduct = $(this).closest('.cart-item').find('.tom_editable_aim.special_char').attr('data-old-value');
            if ($linkedProduct) {  // Proceed only if $linkedProduct is not empty

                // Find the cart item that matches the linked product
                var $linkedProductMatched = $('.cart-item').filter(function () {
                    return $(this).find('.cart_remove_btn').attr('data-product-title') === $linkedProduct;
                });

                if ($linkedProductMatched.length) {  // Check if a matching cart item is found

                    var $linkedPropertyJSON = $linkedProductMatched.attr('data-property');
                    var propertiesArray = [];
                    try {
                        propertiesArray = JSON.parse($linkedPropertyJSON.replace(/'/g, '"'));
                    } catch (e) {
                        console.error('Failed to parse properties JSON:', e);
                    }

                    // Target property to remove
                    var propertyToRemoveMatcher = isSilverLettersField;

                    // Rebuild properties excluding the one to remove
                    var finalProperties = {};
                    propertiesArray.forEach(function (prop) {
                        if (!propertyToRemoveMatcher(prop.name)) {
                            finalProperties[prop.name] = prop.value;
                        }
                    });
                    var $linkedEl = $linkedProductMatched.find('.tom_editable_aim').first();
                    var $linkedKey = $linkedEl.attr('data-key-input');
                    var $linkedProductKey = $linkedEl.attr('data-p-key');

                    if ($linkedKey && $linkedProductKey) {
                        var updateData = {
                            id: $linkedProductKey,
                            quantity: 1,
                            properties: finalProperties
                        };

                        updateData.properties[$linkedKey] = '';  // Clear the property value

                        jQuery.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            data: updateData,
                            dataType: "json",
                            success: function () {
                                // console.log('Connected product properties updated.!', $cart_remove_url);
                                window.location.href = $cart_remove_url;  // Redirect after successful update
                            },
                            error: function (err) {
                                console.error('Failed to update connected product:', err);
                            }
                        });
                    }
                } else {
                    window.location.href = $cart_remove_url;  // If no connected product, just remove the product
                }
            } else {
                window.location.href = $cart_remove_url;  // If no linked product, remove the product
            }


        }
    });

    // --------------------------------------
    $(".tom_add_ins_content p").keypress(function (evt) {
        if (evt.keyCode === 13) {
            evt.preventDefault();
        }
        $(this).closest('.tom_add_ins_content').find('.tom_editable_aim').addClass('saveBtn');
    });
    $(".tom_add_ins_content p").bind("cut copy paste", function (e) {
        e.preventDefault();
    });

    $(window).on("load", function () {
        $(".tom_add_ins_content a").removeClass('saveBtn');
    });
    $('.tom_add_ins_content p').keydown(function (e) {
        if (e.which == 8) {
            $(this).closest('.tom_add_ins_content').find('.tom_editable_aim').addClass('saveBtn');
        }
    });

    $(document).on('change', '.cart-item .quantity__input', function () {
        window.setTimeout(syncSilverLettersQuantitiesFromCart, 700);
    });

    $(document).on('click', '.cart-item .quantity__button', function () {
        window.setTimeout(syncSilverLettersQuantitiesFromCart, 900);
    });
});

function getSilverLettersProductId() {
    return 41188923342892;
}

function findLinkedSilverLettersElement(linkedProductData) {
    return $('.tom_editable_aim.special_char[data-old-value="' + linkedProductData + '"]').first();
}

function syncLinkedSilverLetters(inputText, linkedProductData, parentProductQty) {
    var parentQty = Number(parentProductQty || 1);
    var linkedQty = Number(inputText.length) * parentQty;
    var newLinkedProductData = linkedProductData.split('--')[0] + '--' + inputText;

    var linkedProperties = {
        "_For Product": newLinkedProductData
    };

    if (linkedQty > 0) {
        linkedProperties["silver letters"] = inputText.replaceAll('~', ' ');
    }

    var $existingLinkedItem = findLinkedSilverLettersElement(linkedProductData);

    if ($existingLinkedItem.length) {
        var linkedKeyItem = Number($existingLinkedItem.attr('data-key-item'));

        return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                line: linkedKeyItem,
                properties: linkedProperties,
                quantity: linkedQty
            })
        }).then((response) => response.json());
    }

    if (linkedQty > 0) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                items: [{
                    id: getSilverLettersProductId(),
                    quantity: linkedQty,
                    properties: linkedProperties
                }]
            })
        }).then((response) => response.json());
    }
    return Promise.resolve();
}

function syncSilverLettersQuantitiesFromCart() {
    if (window.tomSilverLettersQtySyncing) {
        return;
    }

    window.tomSilverLettersQtySyncing = true;

    $.getJSON('/cart.json', function (cart) {
        var desiredQuantities = {};
        var desiredValues = {};
        var existingSilverItems = {};
        var updates = {};
        var addItems = [];
        var items = cart.items || [];

        items.forEach(function (item) {
            if (!item || !item.properties) {
                return;
            }

            if (item.id === getSilverLettersProductId()) {
                var linkedProduct = item.properties['_For Product'];
                if (linkedProduct) {
                    existingSilverItems[linkedProduct] = item;
                }
                return;
            }

            Object.keys(item.properties).forEach(function (propertyName) {
                if (!isSilverLettersField(propertyName) || !item.properties[propertyName]) {
                    return;
                }

                var silverValue = String(item.properties[propertyName]);
                var linkedProductData = item.handle + '--' + silverValue.replaceAll(' ', '~');
                var requiredQty = Number(item.quantity || 1) * silverValue.length;

                desiredQuantities[linkedProductData] = (desiredQuantities[linkedProductData] || 0) + requiredQty;
                desiredValues[linkedProductData] = silverValue;
            });
        });

        Object.keys(existingSilverItems).forEach(function (linkedProductData) {
            var existingItem = existingSilverItems[linkedProductData];
            var requiredQty = desiredQuantities[linkedProductData] || 0;

            if (Number(existingItem.quantity || 0) !== requiredQty) {
                updates[existingItem.key] = requiredQty;
            }
        });

        Object.keys(desiredQuantities).forEach(function (linkedProductData) {
            if (existingSilverItems[linkedProductData] || desiredQuantities[linkedProductData] <= 0) {
                return;
            }

            addItems.push({
                id: getSilverLettersProductId(),
                quantity: desiredQuantities[linkedProductData],
                properties: {
                    '_For Product': linkedProductData,
                    'silver letters': desiredValues[linkedProductData]
                }
            });
        });

        var hasUpdates = Object.keys(updates).length > 0;
        var updatePromise = $.Deferred().resolve().promise();

        if (hasUpdates) {
            updatePromise = $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {updates: updates},
                dataType: 'json'
            });
        }

        updatePromise.always(function () {
            if (addItems.length) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: JSON.stringify({items: addItems}),
                    contentType: 'application/json',
                    dataType: 'json'
                }).always(function () {
                    window.tomSilverLettersQtySyncing = false;
                    window.location.reload();
                });
            } else {
                window.tomSilverLettersQtySyncing = false;
                if (hasUpdates) {
                    window.location.reload();
                }
            }
        });
    }).fail(function () {
        window.tomSilverLettersQtySyncing = false;
    });
}

function isSilverLettersAddRequest(settings) {
    if (!settings || settings.url.indexOf('/cart/add') === -1) {
        return false;
    }

    if (typeof settings.data === 'string') {
        return settings.data.indexOf('id=' + getSilverLettersProductId()) !== -1
            || settings.data.indexOf('"id":' + getSilverLettersProductId()) !== -1
            || settings.data.indexOf('"id":"' + getSilverLettersProductId() + '"') !== -1;
    }

    if (settings.data && typeof settings.data === 'object') {
        if (settings.data.id && Number(settings.data.id) === getSilverLettersProductId()) {
            return true;
        }

        if (settings.data.items && settings.data.items.length) {
            return settings.data.items.some(function (item) {
                return Number(item.id) === getSilverLettersProductId();
            });
        }
    }

    return false;
}

function isSilverLettersField(fieldName) {
    return typeof fieldName === 'string' && fieldName.indexOf('3/16” silver letters') === 0;
}